/** @deprecated Use PaymentTerm.id from NetSuite API instead */
export enum PaymentMethod {
  BillAccount = "bill",
  CreditCard = "credit card",
  FullPrepay = "prepay in full",
  DepositPrepay = "50/50 deposit/prepay",
  DepositNet30 = "50/50 deposit/net30",
  Net15 = "net15",
  Net30 = "net30",
  Net60 = "net60",
  Net90 = "net90",
  EarlyBuyRepayment = "eb-repayment",
  ContainerRepayment = "container-repayment"
}

/** @deprecated Use PaymentTerm.name from NetSuite API instead */
export enum PaymentMethodText {
  BillAccount = "Bill the Account",
  CreditCard = "Credit Card",
  FullPrepay = "Prepay (100% Due at Order Placement)",
  DepositPrepay = "50/50: 50% Deposit (Due at Order Placement), 50% Due Before Order Ships",
  DepositNet30 = "50% Deposit, 50% due Net 30 (After Order Ships)",
  Net15 = "Net 15",
  Net30 = "Net 30",
  Net60 = "Net 60",
  Net90 = "Net 90",
  EarlyBuyRepayment = "Early Buy Repayment",
  ContainerRepayment = "Container Repayment"
}

export enum OrderStatus {
  Open = "open",
  Submitted = "submitted",
  Converted = "converted to order"
  // ToDo: FNSI-101 - potentially add "expired"
  // or something to discontinue the use of the
  // unofficial orders and quotes that were not
  // connected to NetSuite
}

export enum OrderType {
  Quote = "quote",
  Order = "order"
}

export enum CreatedType {
  Duplicated = "duplicated"
}

export enum LineItemType {
  Standard = "std",
  Reorder = "reorder",
  EarlyBuy = "eb",
  QS = "quickship"
}

export enum NoteFields {
  Model = "model",
  Canopy = "canopy",
  Frame = "frame",
  Valance = "valance",
  Fringe = "fringe",
  Finial = "finial",
  Rib = "rib",
  BottomPole = "bottomPole",
  Spigot = "spigot",
  Finish = "finish",
  Stem = "stem",
  Options = "options",
  Fabric = "fabric"
}

export enum ShippingAddressType {
  Residential = "Residential",
  Commercial = "Commercial"
}

export enum DeliveryServices {
  LiftGate = "Lift Gate",
  DeliveryAppt = "Delivery Appointment",
  Both = "Lift Gate & Appointment",
  None = "None"
}
